import { render, staticRenderFns } from "./BIMlightweightVisualization.vue?vue&type=template&id=6f6e15c9&scoped=true&"
import script from "./BIMlightweightVisualization.vue?vue&type=script&lang=js&"
export * from "./BIMlightweightVisualization.vue?vue&type=script&lang=js&"
import style0 from "./BIMlightweightVisualization.vue?vue&type=style&index=0&id=6f6e15c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e15c9",
  null
  
)

export default component.exports